"use client";

import { motion, useScroll, useSpring } from "framer-motion";
import { useScrollDepth } from "@/app/hooks/useScrollDepth";
import HeroSection from "@/app/components/landing/HeroSection";
import LiveCounterSection from "@/app/components/landing/LiveCounterSection";
import ChaptersSection from "@/app/components/landing/ChaptersSection";
import SimulatorSection from "@/app/components/landing/SimulatorSection";
import ComingSoonSection from "@/app/components/landing/ComingSoonSection";
import HowItWorksSection from "@/app/components/landing/HowItWorksSection";
import TeamSection from "@/app/components/landing/TeamSection";
import FaqSection from "@/app/components/landing/FaqSection";
import DownloadCTA from "@/app/components/landing/DownloadCTA";

export default function LandingPage() {
  useScrollDepth();
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 120,
    damping: 30,
    mass: 0.8,
  });

  return (
    <>
      <motion.div
        className="scroll-progress"
        style={{ scaleX, width: "100%" }}
        aria-hidden="true"
      />

      <HeroSection />
      <LiveCounterSection />
      <ChaptersSection />
      <SimulatorSection />
      <ComingSoonSection />
      <HowItWorksSection />
      <TeamSection />
      <FaqSection />
      <DownloadCTA />
    </>
  );
}
